var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCards40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.24,-7.10542736e-15 L21.76,-7.10542736e-15 C22.9971178,-7.10542736e-15 24,1.00288216 24,2.24 L24,13.76 C24,14.9971178 22.9971178,16 21.76,16 L2.24,16 C1.00288216,16 0,14.9971178 0,13.76 L0,2.24 C0,1.00288216 1.00288216,-7.10542736e-15 2.24,-7.10542736e-15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/pictogram/ExtraSmall./Cards40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram/cards",
    transform: "translate(8.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.24,-7.10542736e-15 L21.76,-7.10542736e-15 C22.9971178,-7.10542736e-15 24,1.00288216 24,2.24 L24,13.76 C24,14.9971178 22.9971178,16 21.76,16 L2.24,16 C1.00288216,16 0,14.9971178 0,13.76 L0,2.24 C0,1.00288216 1.00288216,-7.10542736e-15 2.24,-7.10542736e-15 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "brand-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "20.2084081 0.5 12.7071138 8.06818647 20.2057962 15.5 29.1442661 15.5 29.1442661 0.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.24,0.5 C1.27902454,0.5 0.5,1.27902454 0.5,2.24 L0.5,13.76 C0.5,14.7209755 1.27902454,15.5 2.24,15.5 L21.76,15.5 C22.7209755,15.5 23.5,14.7209755 23.5,13.76 L23.5,2.24 C23.5,1.27902454 22.7209755,0.5 21.76,0.5 L2.24,0.5 Z",
    id: "Path",
    stroke: "#4F4C4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCards40);
export default __webpack_public_path__ + "static/media/pictogramCards40.173aea9ec8fca8a7f902ed460392c432.svg";
export { ForwardRef as ReactComponent };